import { eurotaxService } from '../../../../services/EurotaxService';
import VehicleConverter from '../../../../utils/VehicleConverter';
import NumberFormatter from '../../../../utils/NumberFormatter';
import modozat from '../../shared/mixins/modozat';

export default {
    mixins: [modozat],
    methods: {
        loadVehicleByEtax(etaxCode) {
            return new Promise((resolve, reject) => {
                eurotaxService.vehicleByEurotaxCode(etaxCode)
                    .then((response) => {
                        if (this.vanCasco) {
                            const gepjarmu = VehicleConverter.etaxToGpjTorzs(response.data);
                            this.etaxcar = response.data;

                            if (this.$store.getters.gepjarmu.fajta) {
                                delete gepjarmu.fajta;
                            }

                            if (this.$store.getters.gepjarmu.sajattomeg) {
                                delete gepjarmu.sajattomeg;
                            }

                            if (this.$store.getters.gepjarmu.ossztomeg) {
                                delete gepjarmu.ossztomeg;
                            }

                            if (this.$store.getters.gepjarmu.teljesitmeny_kw) {
                                delete gepjarmu.teljesitmeny_kw;
                            }

                            if (this.$store.getters.gepjarmu.teljesitmeny_kw_2) {
                                delete gepjarmu.teljesitmeny_kw_2;
                            }

                            if (this.$store.getters.gepjarmu.hengerurtartalom) {
                                delete gepjarmu.hengerurtartalom;
                            }

                            const newGpj = { ...this.$store.getters.gepjarmu, ...gepjarmu };

                            this.$store.commit('setProp', {
                                path: 'gepjarmu',
                                value: newGpj,
                            });
                            if (
                                !this.$store.getters.tarifaData.ujkori_ertek
                                || this.$store.getters.releaseEurotaxUjkoriErtekLock
                            ) {
                                this.$store.commit('setProp', {
                                    path: 'tarifaData.ujkori_ertek',
                                    value: NumberFormatter.toThousandSeparated(response.data.ar),
                                });
                                this.$store.commit('setProp', {
                                    path: 'release_eurotax_ujkori_ertek_lock',
                                    value: false,
                                });
                            }
                        }
                        resolve();
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
    },
};
